import React, { useState } from "react";
import Input from "componentsTemplate/Input/Input";
import ButtonPrimary from "componentsTemplate/Button/ButtonPrimary";
import NcLink from "componentsTemplate/NcLink/NcLink";
import Heading2 from "componentsTemplate/Heading/Heading2";
import Layout from "../layout";
import useAuth from "hooks/useAuth";
import { useForm, Controller } from "react-hook-form";
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup'; // Import this package for TypeScript support
import { showToastError, showToastSuccess } from "utils/toasts";
import { useNavigate } from "react-router-dom";

const PageResetPassword = () => {

  const [loading, setLoading] = useState(false);
  const [code, setCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const email = window.location.search.split('=')[1];

  const navigate = useNavigate();
  const { resetPassword } = useAuth();

  const valideCode = async () => {
    setLoading(true);

    // valide o email com regex
    const regexCode = /^[0-9]{6}$/;
    if (!code || code === '' || !regexCode.test(code)) {
      showToastError("Por favor, informe um código de verificação válido.");
      setLoading(false);
      return;
    }

    // valide a senha
    if (!newPassword || newPassword === '') {
      showToastError("Por favor, informe uma nova senha.");
      setLoading(false);
      return;
    }

    // valide a senha
    if (newPassword !== confirmPassword) {
      showToastError("As senhas não conferem.");
      setLoading(false);
      return;
    }

    try {
      const response = await resetPassword(email, code, newPassword);

      if (response.status) {
        showToastSuccess("Senha alterada com sucesso!");
        navigate('/login');
      }

      setLoading(false);

    } catch (error) {
      showToastError("Código de recuperação de senha inválido'");
      setLoading(false);
    }
  }

  return (
    <Layout>
          {/* <div className={alreadySent ? "hidden" : ""}>
            <header className="text-center max-w-2xl mx-auto - mb-14 sm:mb-16 lg:mb-20">
              <Heading2>Alterar Senha</Heading2>
              <span className="block text-sm mt-2 text-neutral-700 sm:text-base dark:text-neutral-200">
                Bem-vinda, por favor, informe seu e-mail para alterar sua senha.
              </span>
            </header>

            <div className="max-w-md mx-auto space-y-6">
              <form className="grid grid-cols-1 gap-6">
                <label className="block">
                  <span className="text-neutral-800 dark:text-neutral-200">
                    Email
                  </span>
                  <Input
                    type="email"
                    placeholder="exemplo@exemplo.com"
                    className="mt-1"
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </label>
                <ButtonPrimary className="mt-5" loading={loading} onClick={() => sendEmail()}>Continuar</ButtonPrimary>
              </form>

              <span className="block text-center text-neutral-700 dark:text-neutral-300">
                Voltar para {` `}
                <NcLink href="/login">Login</NcLink>
                {` / `}
                <NcLink href="/cadastro">Cadastro</NcLink>
              </span>
            </div>
          </div> */}

          <div>
            <header className="text-center max-w-2xl mx-auto - mb-14 sm:mb-16 lg:mb-20">
              <Heading2>Definir Senha</Heading2>
              <span className="block text-sm mt-2 text-neutral-700 sm:text-base dark:text-neutral-200">
                Bem-vinda, por favor, informe código enviado ao e-mail e a nova senha de acesso.
              </span>
            </header>

            <div className="max-w-md mx-auto space-y-6">

                <label className="block">
                  <span className="flex justify-between items-center text-neutral-800 dark:text-neutral-200">
                    Código de Verificação
                    <NcLink href="/forgot-pass" className="text-sm">
                      Reenviar Código
                    </NcLink>
                  </span>
                  
                  <div>
                    <Input
                      name="code"
                      defaultValue={""}
                      type="text"
                      placeholder="xxxxxx"
                      className="mt-1"
                      onChange={(e) => setCode(e.target.value)}
                    />
                  </div>
                </label>

                <label className="block">
                  <span className="text-neutral-800 dark:text-neutral-200">
                    Nova Senha
                  </span>
                  <Input
                    type="password"
                    placeholder="********"
                    className="mt-1"
                    onChange={(e) => setNewPassword(e.target.value)}
                  />
                </label>

                <label className="block">
                  <span className="text-neutral-800 dark:text-neutral-200">
                    Confirmar Senha
                  </span>
                  <Input
                    type="password"
                    placeholder="********"
                    className="mt-1"
                    onChange={(e) => setConfirmPassword(e.target.value)}
                  />
                </label>

                <div className="flex justify-center">
                  <ButtonPrimary className="mt-5" loading={loading} onClick={() => valideCode()}>Continuar</ButtonPrimary>
                </div>

              {/* </form> */}

              {/* ==== */}
              <span className="block text-center text-neutral-700 dark:text-neutral-300">
                Voltar para {` `}
                <NcLink href="/login">Login</NcLink>
                {` / `}
                <NcLink href="/cadastro">Cadastro</NcLink>
              </span>
            </div>
          </div>
    </Layout>
  );
};

export default PageResetPassword;
